module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Snow3-1d558be9629cf9dd958255af603eb3d6.svg";